var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.flags.loading)?_c('div',{staticClass:"rp-helpcenter-wrapper"},[_vm._m(0)]):_vm._e(),(_vm.flags.noConnectorPresent)?_c('ErrorMessage'):_vm._e()],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lds-ellipsis"},[_c('div'),_c('div'),_c('div'),_c('div')])
}]

export { render, staticRenderFns }